<div class="row">
  <div class="col-sm-3">
    <h3>Ticketreview</h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body"></div>
    </div>
  </div>
</div>

<div class="row newSection">
  <div class="col-sm-3">
    <h3>Aufgaben</h3>
  </div>
</div>

<div class="row">
  @for (device of devices; track device) {
    <div class="col-12 deviceCard">
      <div class="card">
        <div class="card-body">
          <h3>
            {{ device.identifier }}
            @if (device.sub_identifier) {
              <span>{{ device.sub_identifier }}</span>
            }
            @if (device.serial_number) {
              <small>({{ device.serial_number }})</small>
            }
          </h3>
          <div class="row">
            @for (job of device.jobs; track job) {
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    @if (job.job_type !== "checklist_info") {
                      <p>
                        {{ job.id }} <b>{{ job.description }}</b> {{ job.done ? "✓" : "X" }} - {{ job.status }}
                        <button type="button" class="btn btn-success btn-sm">geprüft, ok</button>
                        <button type="button" class="btn btn-danger btn-sm">unzureichend!</button
                        ><span class="float-right"
                          ><small
                            >erledigt: {{ job.done_at | date: "dd.MM.yy HH:mm" }}, updated:
                            {{ job.updated_at | date: "dd.MM.yy HH:mm" }}</small
                          ></span
                        ><br />
                        {{ job.reason }}
                      </p>
                    }
                    @if (job.job_type === "checklist_info") {
                      <h4>{{ job.description }}</h4>
                    }
                  </div>
                </div>
                @if (job.job_type === "picture" || job.job_type === "picture_png") {
                  <div class="row deviceImage">
                    @if (job.reference_image) {
                      <div class="col-4">
                        <img src="{{ job.reference_image }}" />
                      </div>
                    }
                    @if (job.result_image) {
                      <img class="col-4" [defaultImage]="defaultImage" [lazyLoad]="apiImagePath(job.result_image)" />
                    }
                    @if (job.result_overlay_image) {
                      <img
                        class="col-4"
                        [defaultImage]="defaultImage"
                        [lazyLoad]="apiImagePath(job.result_overlay_image)"
                      />
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
